import Accounts from "./Accounts";

const AccountsPage = () => (
	<div className="lavella page accounts-page">
		<section>
			<div className="cont--lg">
				<Accounts />
			</div>
		</section>
	</div>
);

export default AccountsPage;
